import { Link } from 'react-router-dom'
import { APP_VERSION } from '../../version'

interface Props {
  /** Variante de cor — dark pro AppLayout, light pro LoginPage */
  variant?: 'dark' | 'light'
}

export default function Footer({ variant = 'dark' }: Props) {
  const text = variant === 'dark' ? 'text-ink-faint' : 'text-ink-muted'
  const hover = variant === 'dark' ? 'hover:text-ink-muted' : 'hover:text-ink'
  const border = variant === 'dark' ? 'border-line' : 'border-gray-200'

  return (
    <footer className={`shrink-0 border-t ${border} px-3 sm:px-6 py-3 text-xs ${text}`}>
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
        <span>© {new Date().getFullYear()} ax-kanban — todos os direitos reservados.</span>
        <nav className="flex items-center gap-4">
          <Link to="/termos" className={`${hover} transition-colors`}>Termos de Uso</Link>
          <Link to="/privacidade" className={`${hover} transition-colors`}>Privacidade</Link>
          <Link
            to="/configuracoes?tab=sobre"
            className={`${hover} transition-colors tabular-nums`}
            title="Ver detalhes da versão"
          >
            v{APP_VERSION}
          </Link>
        </nav>
      </div>
    </footer>
  )
}
